import React, { useState, useEffect } from 'react';
import { useUrlBuilder } from '../../hooks/useUrlBuilder';
import Row from '../UI/Row';
import { Desktop } from '../MediaQuery/index';
import { ExtendedFooterBox } from '../ExtendedFooterBox/ExtendedFooterBox';
import { getTitleStyle, getTextStyle } from '../ExtendedFooterBox/ExtendedFooterBoxStyles';
import { reviewsCopy, whatWeDoCopy } from './ReadMoreData';
import { press, isHomePage } from '../../helpers/routes';
import PressLogosRow from '../PressLogosRow/PressLogosRow';

/* Components */
const ItalistReadMore: React.FC<{}> = () => {
  const [showFeaturedIn, setShowFeaturedIn] = useState<boolean>(false);
  const titleStyle = getTitleStyle();
  const textStyle = getTextStyle();
  const { localized } = useUrlBuilder();
  const whatWeDoCopyLocalized = whatWeDoCopy(localized);
  const reviewsCopyLocalized = reviewsCopy(localized);

  useEffect(() => {
    setShowFeaturedIn(isHomePage());
  }, []);

  return (
    <div className="read-more-container">
      <div className="read-more-boxes-container">
        <ExtendedFooterBox
          bottomText
          link={whatWeDoCopyLocalized.link}
          mainContent={whatWeDoCopyLocalized.text}
          padding="50px 66px 20px"
          squareBorder
          title={whatWeDoCopyLocalized.title}
        />

        <ExtendedFooterBox
          bottomText
          link={reviewsCopyLocalized.link}
          mainContent={reviewsCopyLocalized.text}
          oblique
          padding="55px 66px 0"
          squareBorder
          title={reviewsCopyLocalized.title}
        />
      </div>
      {showFeaturedIn && (
        <Desktop>
          <Row margin="46px 0 30px 0">
            <div style={{ display: 'flex', flex: '1', justifyContent: 'center' }}>
              <span className={`extended-footer-title ${titleStyle.className}`} style={{ margin: 0 }}>
                As featured in
              </span>
            </div>
          </Row>
          <PressLogosRow commonLink={localized(press)} />
          {titleStyle.styles}
          {textStyle.styles}
        </Desktop>
      )}
      <style jsx>
        {`
          .read-more-container {
            width: 100%;
            max-width: 1280px;
            margin: 35px auto 25px;
          }
          .read-more-boxes-container {
            display: flex;
          }
          @media (max-width: 1023px) {
            .read-more-boxes-container {
              margin-top: 20px;
              flex-direction: column;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ItalistReadMore;
